import Text from "ab-text";

import "./ab-expertos.scss";

const Expertos = ({
  title = "Logros alcanzados y objetivos de futuro",
  text = [
    "Ya puede conocer en Nuestra Quinta Memoria de RSE 2020,  logros alcanzados y objetivos para los próximos años, siempre basados en nuestros cinco pilares fundamentales.",
  ],
  cards = [],
  className = "",
  classname = "",
}) => {
  return (
    <div className={`ab-expertos ${className || classname || ""}`}>
      <div className="details">
        <Text element="h2">{title}</Text>

        <Text>{text}</Text>
      </div>

      <div className="logros">
        {cards?.map((itm) => (
          <div className="logro-card">
            <picture>
              <source
                srcSet={itm?.imagemobile?.mediaItemUrl || itm.imagemobile}
                media="(max-width: 850px)"
              />
              <img
                src={itm?.image?.mediaItemUrl || itm.image}
                loading="lazy"
                alt={itm.title}
              />
            </picture>

            <div>
              <Text element="h4">{itm.title}</Text>
              <Text element="span" className="title">
                {itm.subtitle}
              </Text>
              <Text>{itm.description}</Text>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Expertos;
